// MUI
import { Box, Typography } from '@mui/material';

// Components
import { EnvironmentBadge } from '../../../../components';

const LoginHeader = () => {
  return (
    <Box sx={{ textAlign: 'center', marginBottom: 3 }}>
      <Box
        component="img"
        src="/logo.png"
        alt="VCAT Logo"
        sx={{
          display: 'block',
          mx: 'auto',
          width: { xs: 120, sm: 150 },
        }}
      />

      <EnvironmentBadge />

      <Typography
        variant="h5"
        sx={{
          color: '#FFFFFF',
          fontWeight: 'bold',
          mt: 3
        }}
      >
        Log in
      </Typography>
    </Box>
  );
};

export { LoginHeader };